import LoanCalculator from "@/components/LoanCalculator";

export default function CalculatorPage() {
  return (
    <div className="container mx-auto px-6 py-12">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-3">
            Loan calculator
          </p>
          <h1 className="text-3xl font-bold text-foreground font-display sm:text-4xl">
            See what you'll pay
          </h1>
          <p className="mx-auto mt-3 max-w-lg text-base text-muted-foreground">
            Play with the numbers and find a loan that fits your budget. No account needed.
          </p>
        </div>
        <LoanCalculator />
      </div>
    </div>
  );
}
